module.exports = __webpack_public_path__ + "img/person4.b63a6eee.png";